import script from "./ConfigTypeDoc.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigTypeDoc.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__